import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import Unauthorized from 'views/pages/maintenance/Unauthorized';

// maintenance routing
const MaintenanceError = Loadable(lazy(() => import('views/pages/maintenance/NotFoundError')));
const MaintenanceComingSoon1 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon1')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('views/pages/maintenance/ComingSoon/ComingSoon2')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('views/pages/maintenance/UnderConstruction')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/error',
            element: <MaintenanceError />
        },
        {
            path: '/unauthorized',
            element: <Unauthorized />
        },
        {
            path: '/coming-soon1',
            element: <MaintenanceComingSoon1 />
        },
        {
            path: '/coming-soon2',
            element: <MaintenanceComingSoon2 />
        },
        {
            path: '/under-construction',
            element: <MaintenanceUnderConstruction />
        }
    ]
};

export default AuthenticationRoutes;
